module.exports = __webpack_public_path__ + "static/media/sidharth-bhatia-358983-unsplash-sm.401382f5.jpg";